<template>
  <div class="table offer-info">
    <div v-for="(round,index) in tableList" v-if="showRound(round)">
      <div>Round {{round.roundNumber}}
        <!--下载本轮次Excel-->
        <el-button v-if="ssr.owned" type="primary" @click="goMark(round.ttSsrRoundId)">Score</el-button>
      </div>
      <el-table :data="round.ssrRoundSuppliers.filter(sup=>sup.status != 'REFUSE')" ref="table" border highlight-current-row style="margin-top:15px;">
        <el-table-column show-overflow-tooltip prop="supplierCode" label="Supplier Code" width="170"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierName" label="Supplier Name For Short" min-width="140"></el-table-column>
        <el-table-column show-overflow-tooltip v-for="item in scoreItems" :label="item" :width="item.length*15">
          <template slot-scope="scope">{{scope.row.markInfo.scoreMap[item]}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="Total Score" width="200">
          <template v-if="scope.row.markInfo !=null&&scope.row.markInfo.totalScoreSs != null" slot-scope="scope">
            <el-link v-if="!isSupplier" type="primary" @click="goMark(round.ttSsrRoundId)">{{scope.row.markInfo.totalScoreSs}}</el-link>
            <span v-if="isSupplier">{{scope.row.markInfo.totalScoreSs}}</span>
            <el-button style="margin-left: 1em;" type="primary" size="small" v-if="scope.row.markInfo.shareFlag=='N' && ssr.owned" :title="$t('ssrManage.shareMark')" @click="shareScore(scope.row.markInfo,scope.$index,index)">Share Score</el-button>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="roundStatus" label="Review Outcome" width="160">
          <template slot-scope="scope">
            <ic-select :disabled="!canEdit(round)" @change="changeRoundSupplierStatus(scope.row.roundStatus,scope.$index,index)" table="TT_SSR" field="ROUND_SUPPLIER_STATUS" v-model="scope.row.roundStatus"></ic-select>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="Result communication" width="200">
          <template slot-scope="scope">
            <el-upload :show-file-list="false" v-if="canEdit(round)" :action="supFileUploadAction(scope.row.ttSsrRoundSupplierId)" :on-success="upload(index,scope.$index)" :headers="supFileUploadHeaders">
              <el-link type="primary">upload</el-link>
            </el-upload>
            <file-list :can-edit="canEdit(round)" :files="scope.row.markDocs"></file-list>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="comments" v-if="!isSupplier" label="Comment" width="160">
          <template slot-scope="scope">
            <el-input :disabled="!canEdit(round)" v-model="scope.row.comments"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding-top: 15px;">
        <file-upload :disabled="!canEdit(round)" title="Businsess Recommendation" rec-type="SSR" seq="ROUND_MARK" :biz-id="round.ttSsrRoundId" v-model="round.markDocs"></file-upload>
      </div>
      <!--底部操作按钮-->
      <el-row type="flex" justify="center" style="padding-top: 15px;" v-if="canEdit(round)">
        <el-button type="primary" @click="save('SAVE')">Save As Draft</el-button>
        <el-button type="primary" @click="save('SUBMIT')">{{submitButton(round)}}</el-button>
        <el-button type="primary" v-if="canCreateBc" @click="createBc()">{{$t('ssrManage.createBc')}}</el-button>
      </el-row>
    </div>
    <el-row type="flex" justify="center" style="padding: 15px 0;" v-if="canCreateBc">
      <el-button type="primary" @click="save('SUBMIT')">{{submitButton(round)}}</el-button>
      <el-button v-if="ssr.type == 'RFP'" type="primary" @click="createBc()">{{$t('ssrManage.createBc')}}</el-button>
    </el-row>
  </div>
</template>
<script>
import router from '../../../router';
import { apiService } from "@/api/ssr-manage/ssr-manage";
import { Message } from "element-ui";
import { fileService } from "../../../api/common/file-utils";
import commonMethods from "@/utils/commonMethods";
import FileUpload from "@/components/common/fileUpload";
import FileList from "@/components/common/fileList";
import commonConstants from "@/constants/commonConstants";
import commonFun from "@/utils/commonFun";
import IcSelect from "@/components/common/icSelect";

export default {
  name: 'spm-core-pane',
  extends: commonMethods,
  components: { IcSelect, FileList, FileUpload },
  props: {
    rounds: Array,
    ssr: Object
  },
  computed: {
    type() {
      return this.$route.meta.type;
    },
    submitButton(round) {
      let that = this;
      return (round) => {
        if (commonFun.isEmpty(that.ssr)) {
          return 'Submit';
        }
        if (that.ssr.type == 'RFP') {
          return 'Submit';
        }
        if (commonFun.isNotEmpty(round) && commonFun.isNotEmpty(round.ssrRoundSuppliers) && round.ssrRoundSuppliers.some(row => row.roundStatus == 'AWARD')) {
          return this.$t("ssrManage.publish");
        }
        return 'Submit';
      };
    },
    showRound(round) {
      return function (round) {
        if (["DRAFT", "ISSUED"].indexOf(round.status) >= 0) {
          return false;
        }
        if (this.isSupplier) {
          if (round.ssrRoundSuppliers != null && round.ssrRoundSuppliers.length > 0) {
            return round.ssrRoundSuppliers[0].markInfo != null;
          }
          return false;
        } else {
          return true;
        }
      };
    },
    supFileUploadHeaders: function () {
      return {
        'x-access-token': localStorage.getItem('token')
      };
    },
    scoreItems() {
      if (!commonFun.isSupplier()) {
        return [];
      }
      return this.ssr.markItems;
    },
    outcomeOption: function () {
      return commonFun.listIC("TT_SSR", "ROUND_SUPPLIER_STATUS")
    },
    canEdit: function () {
      let that = this;
      return (round) => {
        return that.ssr.owned && round.status === "QUOTED"
      }
    },
    canCreateBc() {
      return this.ssr.owned && this.ssr.status == 'RECOMMENDATION'
    }
  },
  data() {
    return {
      radio: '1',
      labelPosition: 'right',
      tableList: [{ ssrRoundSuppliers: [] }],
      facilityOption: [],
      currencyOption: [],
    }
  },
  watch: {
    rounds(val) {
      this.tableList = val;
    }
  },
  methods: {
    createBc() {
      apiService.createBc(this.ssr.ttSsrId).then(res => {
        if (res.code == 200) {
          Message.success('Operate Success')
        }
      });
    },
    shareScore(markInfo, index, roundIndex) {
      let that = this;
      apiService.shareScore(markInfo.ttSupplierMarkSupplierId).then(res => {
        if (res.code == 200) {
          Message.success(that.$t("ssrManage.shareMarkSuccess"));
          that.$set(markInfo, 'shareFlag', 'Y');
        }
      });
    },
    supFileUploadAction: function (roundSupId) {
      return `${commonConstants.fileUploadUrl}/SSR/ROUND_MARK_SUP/${roundSupId}`;
    },
    goMark(roundId) {
      let that = this;
      apiService.getMarkId(roundId).then(res => {
        if (res.code == 200) {
          let spmId = res.data;
          that.$router.push({ name: "spm-manage-detail", query: { id: spmId } })
        }
      });
    },
    upload(roundIndex, supIndex) {
      let that = this;
      return (response, file, fileList) => {
        that.tableList[roundIndex].ssrRoundSuppliers[supIndex].markDocs.push(...response.data);
      };
    },
    save(status) {
      let that = this;
      let lastRound = this.rounds[this.rounds.length - 1];
      let haveAward = false;
      let haveContinue = false;
      lastRound.ssrRoundSuppliers.forEach(sup => {
        if (sup.roundStatus == "AWARD") {
          haveAward = true;
        }
        if (sup.roundStatus == "CONTINUE") {
          haveContinue = true;
        }
      })
      if (haveContinue && haveAward) {
        Message.error(this.$t("ssrManage.reviewOutcomeError"));
        return;
      }
      let data = {
        ssrRoundId: lastRound.ttSsrRoundId,
        status: status,
        roundSupplierList: lastRound.ssrRoundSuppliers
      };
      apiService.saveMarkInfo(data).then(res => {
        if (res.code == 200) {
          if (status == 'SUBMIT' && haveAward && that.ssr.type == 'SSR') {
            Message.success(that.$t("ssrManage.bcCreated"));
            that.$router.push({ path: `/BC` });
          } else {
            Message.success('Operate Success');
            that.$router.push({ path: `/${that.type}-manage` });
          }
          // if (that.ssr.type == 'RFP') {
          //     Message.success('Operate Success');
          // } else if (haveAward) {
          //     Message.success(that.$t("ssrManage.bcCreated"));
          // } else {
          //     Message.success('Operate Success');
          // }
          // that.$router.push({path: `/${that.type}-manage`});
        }
      });
    },
    changeRoundSupplierStatus(status, index, roundIndex) {
      // if ("AWARD" == status) {
      //     this.tableList[roundIndex].ssrRoundSuppliers.filter((item,i)=>index != i && item.roundStatus != "AWARD").forEach(item=>{
      //         item.roundStatus = "DISCONTINUED";
      //     })
      // }
    }
  }
}
</script>
<style scoped></style>
